export default {
	title: "Personal Center",
	subTitle: ["Profile", "Security", "System"],
	menu: ["Modify Personal Information", "Username", "Update Password", "Update Transaction Password"],
	updatePassword: {
		form: {
			label: ["Old Password", "New Password", "Confirm New Password"]
		}
	},
	updateTransactionPassword: {
		form: {
			label: ["Old Password", "New Password", "Confirm New Password"]
		}
	}
};
